import type { RouteRecordRaw } from 'vue-router'

export const docgenRoutes: RouteRecordRaw[] = [
  {
    path: 'docgen',
    name: 'docgen-home',
    component: () => import('@docgen/pages/DocGenHomePage.vue'),
  },
  {
    path: 'docgen/builder',
    name: 'docgen-builder',
    component: () => import('@docgen/pages/DocGenBuilderPage.vue'),
  },
  {
    path: 'docgen/builder/:id',
    name: 'docgen-builder-edit',
    component: () => import('@docgen/pages/DocGenBuilderPage.vue'),
  },
  {
    path: 'docgen/dashboards',
    name: 'docgen-dashboard',
    component: () => import('@docgen/pages/DocGenDashboardPage.vue'),
  },
  {
    path: 'docgen/dashboard-builder/:id',
    name: 'docgen-dashboard-builder',
    component: () => import('@docgen/pages/DocGenDashboardBuilderPage.vue'),
  },
  {
    path: 'docgen/settings',
    name: 'docgen-settings',
    component: () => import('@docgen/pages/DocGenSettingsPage.vue'),
  },
]
